import { render, staticRenderFns } from "./SolicitudTransferencias.vue?vue&type=template&id=d7296fd0&scoped=true"
import script from "./SolicitudTransferencias.vue?vue&type=script&lang=js"
export * from "./SolicitudTransferencias.vue?vue&type=script&lang=js"
import style0 from "./SolicitudTransferencias.vue?vue&type=style&index=0&id=d7296fd0&prod&scoped=true&lang=css"
import style1 from "./SolicitudTransferencias.vue?vue&type=style&index=1&id=d7296fd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7296fd0",
  null
  
)

export default component.exports